// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const PhoneRecordsAPI = {
    /**
     * Returns list of call records for the given set of locations sorted by descending order with applied filters (if passed) in the request.
     */
    GetCallRecords(fn, req) {
        return fn(`/phone-exp/phone-records/v1/call-records?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteCallRecordings(fn, req) {
        return fn(`/phone-exp/phone-records/v1/call-recordings?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    MarkAllCallRecordsViewed(fn, req) {
        return fn(`/phone-exp/phone-records/v1/call-records/mark-all-viewed`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetCallRecordsByPersonIds(fn, req) {
        return fn(`/phone-exp/phone-records/v1/call-records-by-person-ids?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Get call records with recording, office user, caller person detail for the given set of locations with applied
     * filters (if passed) in the request. Used in NWX
     */
    GetHydratedCallRecords(fn, req) {
        return fn(`/phone-exp/phone-records/v1/hydrated-call-records?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Get all the call records for a possibly cancelled weave customer
     */
    ExportAllCallRecords(fn, req) {
        return fn(`/phone-exp/phone-records/v1/exports/all-call-records?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetCallRecordsExportSignedURL(fn, req) {
        return fn(`/phone-exp/phone-records/v1/exports/call-records-signed-url?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Returns list of voicemails for the give locations with applied filters passed (pagination, mailbox, callername,
     * read status etc.) in the request
     */
    ListVoicemails(fn, req) {
        return fn(`/phone-exp/phone-records/v1/voicemails?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * get the count of unread voicemails grouped by mailbox
     */
    CountUnreadVoicemails(fn, req) {
        return fn(`/phone-exp/phone-records/v1/count-unread-voicemails?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * apply tags to a voicemail message
     */
    ApplyVoicemailMessageTags(fn, req) {
        return fn(`/phone-exp/phone-records/v1/apply-voicemail-message-tags`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * remove tags from a voicemail message
     */
    RemoveVoicemailMessageTags(fn, req) {
        return fn(`/phone-exp/phone-records/v1/remove-voicemail-message-tags`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     *Returns list of voicemails boxes for the given location ids.
     * GET: phone-exp/phone-records/v1/voicemail-mailboxes
     */
    ListVoicemailBoxes(fn, req) {
        return fn(`/phone-exp/phone-records/v1/voicemail-mailboxes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *Returns list of voicemails for the give location with applied filters passed (pagination, mailbox, callername)
     */
    ListVoicemailMessages(fn, req) {
        return fn(`/phone-exp/phone-records/v1/voicemail-messages?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * --------------------------------- ALL WIDGETS RELATED ENDPOINTS ---------------------------------
     * Get call results for the given location ids and time range
     */
    GetCallResults(fn, req) {
        return fn(`/phone-exp/phone-records/v1/widget/call-results?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Get phone snapshot data for the given location ids and time range
     */
    GetPhoneSnapshotData(fn, req) {
        return fn(`/phone-exp/phone-records/v1/widget/phone-snapshot?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
